// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"293":"7be9f39e71eab004a137","454":"e158b979e2ee5e429ab6"}[chunkId] + ".js";
};